<template>
  <div class="row mx-0 me-md-3">
    <div class="col-12 col-md-4 px-0">
      <SchoolName />
    </div>
    <div class="col-12 col-md-4 px-0">
      <Faculty />
    </div>
    <div class="col-12 col-md-4 px-0">
      <Graduation />
    </div>
  </div>
</template>

<script setup lang="ts">
import SchoolName from './SchoolName.vue';
import Faculty from './Faculty.vue';
import Graduation from './Graduation.vue';
</script>
